import React, { useState } from 'react';
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import BrandImage from './BrandImage';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const BrandCarousel = () => {
  const navigate = useNavigate();
  const [failedImages, setFailedImages] = useState<Set<string>>(new Set());

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 10000,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    slidesToShow: 8,
    pauseOnHover: true,
    cssEase: "linear",
    rtl: false,
    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: 7,
          speed: 7000,
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 6,
          speed: 6000,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          speed: 5000,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          speed: 4500,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          speed: 4000,
        }
      }
    ]
  };

  const handleBrandClick = (brandName: string) => {
    navigate(`/catalog?brand=${encodeURIComponent(brandName)}`);
  };

  const handleImageError = (brandName: string) => {
    console.warn(`[BrandCarousel] Marca "${brandName}" omitida por error al cargar imagen.`);
    setFailedImages(prev => new Set(prev).add(brandName));
  };

  const brands = [
    { name: '3M', logo: 'https://www.lubeseguridad.com.ar/scroll/000200122757900010001201913m.png' },
    { name: 'LAKELAND', logo: 'https://www.lakeland.com/wp-content/uploads/elementor/thumbs/lakeland-fire-safety-white-225x57-1-qt736ti477vx1tra2mah3yomp0dijclyphy2wim6ii.webp' },
    { name: 'WYPALL', logo: 'https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/052013/wypall.png?itok=hH7vqNTt' },
    { name: 'LIBUS', logo: 'https://www.lubeseguridad.com.ar/scroll/0002000928860marca-libus.jpg' },
    { name: 'STEELPRO', logo: 'https://www.lubeseguridad.com.ar/scroll/0002000528948marca-steel.jpg' },
    { name: 'OMBU', logo: 'https://www.lubeseguridad.com.ar/scroll/00020008275380001001120242ombu.png' },
    { name: 'FUNCIONAL', logo: 'https://www.lubeseguridad.com.ar/scroll/00020002275380001001020242funcional.png' },
    { name: 'PAMPERO', logo: 'https://pampero.com.ar/wp-content/uploads/2024/07/logosimbolo.png' },
    { name: 'GRAFA70', logo: 'https://grafa70.com.ar/wp-content/uploads/2019/03/cropped-logo_1-2.png' },
    { name: 'MARTOR', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Martor_Logo.svg/960px-Martor_Logo.svg.png?20140805082504' },
    { name: 'GAMISOL', logo: 'https://www.gamisol.com.ar/wp-content/uploads/2023/12/isologotipoGamisol.svg' },
    { name: 'EAGLE', logo: 'https://eaglesafety.com/wp-content/uploads/2019/09/eagle-safety-logo-small.png' },
    { name: 'BILVEX', logo: 'https://112cc5d764.cbaul-cdnwnd.com/9f0af1af3b99aa2b896bd83211c7b1c6/system_preview_detail_200000030-886bc89675-public/LOGO%20BIL%20VEX.jpg' },
    { name: 'PRENTEX', logo: 'https://www.cas-seguridad.org.ar/wp-content/uploads/2020/08/logo-prentex.png' },
    { name: 'CONOFLEX', logo: 'https://segutex.com.ar/wp-content/uploads/2016/05/logo-conoflex.png' },
    { name: 'MAPA', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJphoHPOqPZSOxa9WoIxRzP_XN-MJ8pvwMow&s' },
    { name: 'DP', logo: 'https://depascale.com.ar/wp-content/uploads/2025/07/De_Pascale_logo.png' },
    { name: 'UCU', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvK05ZX2xngnZgkhvCida_KjPOGhp2FgNczA&s' }
  ];

  const filteredBrands = brands.filter(brand => !failedImages.has(brand.name));

  return (
    <section className="w-full bg-gray-100">
      <div className="py-6">
        <div className="w-full">
          <Slider {...settings}>
            {filteredBrands.map((brand, index) => (
              <div key={index} className="px-2">
                <div
                  className="h-32 bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center p-4 transform hover:-translate-y-1 cursor-pointer"
                  onClick={() => handleBrandClick(brand.name)}
                >
                  <div className="w-full h-full flex items-center justify-center">
                    <BrandImage
                      src={brand.logo}
                      alt={brand.name}
                      className="max-w-[85%] max-h-24 object-contain mx-auto"
                      fallbackType="hide"
                      onError={handleImageError}
                    />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default BrandCarousel;
